import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/router";

import { getCategoryPath } from "../../core/category.core";
import { useTranslation } from "../../core/translation.core";
import ChevronRightIcon from "../../icons/chevronRight.icon";
import Skeleton from "../common/skeleton.comp";

export default function CategoryBreadcrumbsComp({ showAllCategoryInRoot = true }: { showAllCategoryInRoot?: boolean }) {
  const { query } = useRouter();
  const { t, msg } = useTranslation();

  const catId = query.catId as string;

  const { data, isFetched } = useQuery({
    enabled: catId !== null && catId !== undefined,
    queryFn: (context) => getCategoryPath(context.queryKey[1]),
    queryKey: ["categoryPath", catId],
  });

  if (!catId) {
    if (!showAllCategoryInRoot) return null;
    return (
      <div className="dark:text-white flex items-center gap-1">
        <span>{t(msg.pos.allCatgories)}</span>
      </div>
    );
  }

  if (!isFetched) {
    return <Skeleton />;
  }

  return (
    <div id="cat-breadcrumbs" className="flex items-center gap-3">
      <Link href="/category" className="dark:text-white flex items-center gap-1 cursor-pointer">
        <span>{t(msg.pos.allCatgories)}</span>
        <ChevronRightIcon className="w-4 h-4" />
      </Link>
      {/* @ts-ignore */}
      {data.map((item, index) => {
        //  @ts-ignore
        if (index + 1 === data.length) {
          return (
            <div className="`dark:text-white flex items-center gap-1" key={index}>
              <span className="font-light text-gray-400">{item.name}</span>
            </div>
          );
        }

        return (
          <Link
            key={index}
            href={`/category?catId=${item.id}`}
            //  @ts-ignore
            className={`dark:text-white flex items-center gap-1 ${index + 1 != data.length ? "cursor-pointer" : ""}`}
          >
            <span>{item.name}</span>
            {/* @ts-ignore */}
            {index + 1 != data.length && <ChevronRightIcon className="w-4 h-4" />}
          </Link>
        );
      })}
    </div>
  );
}
